<ng-content></ng-content>

<ng-container *ngIf="showOverlay">
  <ng-container *ngIf="!asPopup">
    <visana-lib-button
      (click)="animateOut = true"
      [class.animate-out]="animateOut"
      buttonSize="large"
      class="shrink close-button"
      iconName="cross-small"
      iconPosition="left"
      iconSize="24"
      variant="white-violet"
      data-analytics="contact-overlay_close"
      >{{ 'CONTACT_OVERLAY.CLOSE' | translate }}
    </visana-lib-button>
    <div (animationend)="onAnimationEnd($event)" [class.animate-out]="animateOut" class="overlay">
      <ssc-contact-overlay-content
        [padded]="true"
        [title]="'CONTACT_OVERLAY.TITLE' | translate"
      ></ssc-contact-overlay-content>
    </div>

    <visana-lib-overlay-backdrop (click)="animateOut = true" *ngIf="!animateOut"></visana-lib-overlay-backdrop>

    <visana-lib-scroll-lock></visana-lib-scroll-lock>
  </ng-container>

  <visana-lib-popup
    (cancel)="overlayClosed.emit()"
    *ngIf="asPopup"
    variant="violet"
    [isOpen]="true"
    [title]="'CONTACT_OVERLAY.TITLE' | translate"
  >
    <ssc-contact-overlay-content ngProjectAs="content"></ssc-contact-overlay-content>
  </visana-lib-popup>
</ng-container>
